import React, { useEffect, useState } from "react";
import eyeLearn from "../../assets/images/courseIcons/eyeLearn.svg";
import { getAllResourceList, getFavouriteList } from '../../lib/api';
import LoadingSpinner from "../UI/LoadingSpinner";

const ExploreApps = ({ isToggle, exploreAppsRef }) => {
    const [listApplication, setListApplication] = useState([]);
    const [listFavouriteApplication, setListFavouriteApplication] = useState([]);
    const [toggleState, setToggleState] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getApplications();
    }, []);

    const handleToggle = () => {
        setToggleState(!toggleState);
        if (!toggleState) {
            getFavouriteApplication();
        } else {
            getApplications();
        }
    };

    const getFavouriteApplication = () => {
        setIsLoading(true)
        getFavouriteList()
            .then((response) => {
                const data = response.map((details) => ({
                    id: details.tid,
                    value: details.name,
                }));
                setListFavouriteApplication(data);
                setIsLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false)
            });
    };

    const getApplications = () => {
        setIsLoading(true)
        getAllResourceList()
            .then((response) => {
                const data = response.map((details) => ({
                    id: details.tid,
                    value: details.name,
                }));
                setListApplication(data);
                setIsLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false)
            });
    };

    return (
        <div ref={exploreAppsRef} className="notificationHolder top-0 fixed right-0 z-50 bg-white shadow-profileMenuShadow min-h-[100vh] w-[400px] group-hover:block">
            {isLoading && (
                <div className="parentDisable">
                    <LoadingSpinner />
                </div>
            )}
            <div className="py-5 flex flex-col max-[420px]:h-screen max-[420px]:gap-4">
                <div className="flex-1 basis-[80%] overflow-auto">
                    <div className="notificationHeader flex justify-between items-center px-4 sm:px-6">
                        <h2 className="notificationTitle text-[#333] text-[18px] leading-normal barlowBold uppercase">RESOURCE MANAGER</h2>
                        <div className="closeIconHolder cursor-pointer" onClick={isToggle}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M4.7475 20.1575C4.5575 20.1575 4.3675 20.0875 4.2175 19.9375C3.9275 19.6475 3.9275 19.1675 4.2175 18.8775L17.8775 4.2175C18.1675 3.9275 18.6475 3.9275 18.9375 4.2175C19.2275 4.5075 19.2275 4.9875 18.9375 5.2775L5.2775 19.9375C5.1375 20.0875 4.9375 20.1575 4.7475 20.1575Z" fill="#717375" stroke="#717375"></path>
                                <path d="M18.4075 20.1575C18.2175 20.1575 18.0275 20.0875 17.8775 19.9375L4.2175 5.2775C3.9275 4.9875 3.9275 4.5075 4.2175 4.2175C4.5075 3.9275 4.9875 3.9275 5.2775 4.2175L18.9375 18.8775C19.2275 19.1675 19.2275 19.6475 18.9375 19.9375C18.7875 20.0875 18.5975 20.1575 18.4075 20.1575Z" fill="#717375" stroke="#717375"></path>
                            </svg>
                        </div>
                    </div>
                    <div
                        className="myFavToggler flex items-center gap-3 bg-[#d9d9d94d] py-3 px-4 sm:px-6 mt-3">
                        <div className="switchHolder">
                            <label className="toggle">
                                <input className="toggle-checkbox" type="checkbox" checked={toggleState} onChange={handleToggle} />
                                <div className="toggle-switch"></div>
                                <span className="toggle-label"></span>
                            </label>
                        </div>
                        <p className="text-[#333] font-medium text-lg leading-6 tracking-[-0.045px]">
                            {toggleState ? "My Favourite" : "All Resources"}
                        </p>
                    </div>
                    <div className="notificationBody mt-2 px-4 sm:px-6">
                        {(toggleState ? listFavouriteApplication : listApplication).map((item, index) => (
                            <div key={index} className="appsItem cursor-pointer">
                                <div className="flex items-center gap-4 border-b border-[#E4E8F0] pb-4 pt-3">
                                    <div className="appIconHolder size-8 shrink-0">
                                        <img src={eyeLearn} className="size-full" alt="apps icon" />
                                    </div>
                                    <div className="appName text-[#333] barlowBold text-xl leading-6 capitalize tracking-[-0.05px]">
                                        {item.value}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* <div className="exploreAppsBtnHolder px-4 sm:px-6">
                    <button className="btn loginBtn bg-primaryBlue h-[46px] w-[150px] mr-auto font-bold leading-5 text-base justify-center items-center rounded text-white text-center flex !mt-[60px]" target="_blank">
                        Explore Apps
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default ExploreApps;